module.exports = __webpack_public_path__ + "img/r00.16332b84.png";